import { schemaApi } from "../../api/schemaApi"

import { addNotification, NotificationTypes } from "./notificationActions"

import { componentConfigSchemaSignal, componentConfigSchemaLoadedSignal, componentConfigSchemaErrorSignal, componentConfigSchemaVersionSignal, componentConfigSchemaIsMigratedSignal, ccSchemaUtgGlobalSignal, ccSchemaCoreGlobalSignal, ccSchemaProactorSupervisorSignal, ccSchemaExpressManagerSignal, ccSchemaMailServerSignal, ccSchemaWebServerSignal, ccSchemaApiInterfaceConfigSignal } from '../signals/componentConfigSchemaSignals'

export const fetchComponentConfigSchema = async (businessEntityId, utgVersion, config, accessToken, signal=null) => {
    try {
        componentConfigSchemaLoadedSignal.value = false
        componentConfigSchemaSignal.value = null
        componentConfigSchemaVersionSignal.value = utgVersion; // allows us to short-circuit future calls when the data is already loaded

        // if app config file has loadLocalComponentConfigSchema enabled, load that instead of from database. This is useful for development/debugging schema updates
        let componentConfigSchema
        if (config.loadLocalComponentConfigSchema) {
            componentConfigSchema = await schemaApi.fetchComponentConfigSchemaLocal(utgVersion, signal)
        }
        else {
            componentConfigSchema = await schemaApi.fetchComponentConfigSchema(config, utgVersion, signal)
        }
        //console.log("Component config schema:")
        //console.log(componentConfigSchema)
        if (!('schema' in componentConfigSchema)) {
            throw new Error("Value returned by schemaApi.fetchComponentConfigSchema doesn't have a property 'schema'")
        }
        let parsed = JSON.parse(componentConfigSchema.schema)
        //console.log("Parsed the following component config schema")
        //console.log(parsed)
        componentConfigSchemaIsMigratedSignal.value = !!parsed['s4-migrated']
        componentConfigSchemaSignal.value = parsed

        //utgGlobal
        ccSchemaUtgGlobalSignal.value = parsed.properties.config.properties.utgGlobal
        //coreGlobal
        ccSchemaCoreGlobalSignal.value = parsed.properties.config.properties.coreGlobal
        //proactorSupervisor
        ccSchemaProactorSupervisorSignal.value = parsed.properties.config.properties.proactorSupervisor
        //expressManager
        ccSchemaExpressManagerSignal.value = parsed.properties.config.properties.expressManager
        //mailServer
        ccSchemaMailServerSignal.value = parsed.properties.config.properties.mailServer
        //webServer
        ccSchemaWebServerSignal.value = parsed.properties.config.properties.webServer
        //apiInterfaceConfig
        ccSchemaApiInterfaceConfigSignal.value = parsed.properties.config.properties.apiInterfaceConfig

        componentConfigSchemaLoadedSignal.value = true
        return componentConfigSchema.value
    } catch (err) {
        componentConfigSchemaErrorSignal.value = err
        componentConfigSchemaVersionSignal.value = null
        //console.log(err)
        addNotification(`Unable to load data due to the following error - ${err}`, NotificationTypes.ERROR, true, "Error fetching component config schema")
    }
}